export default "__VITE_ASSET__7rIH6npk__"